"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentWriteKeyForTracking = void 0;
exports.preInit = preInit;
exports.default = init;
const analytics_next_1 = require("@segment/analytics-next");
const segmentIntegrations_1 = require("./lib/segmentIntegrations");
const plugins_1 = require("./plugins");
const cookies_1 = require("./lib/cookies");
const debugHelper_1 = require("./lib/debugHelper");
const oneTrustCookieHelper_1 = require("./lib/oneTrustCookieHelper");
const windowEventHelper_1 = require("./lib/windowEventHelper");
const trackingHelper_1 = require("./lib/trackingHelper");
let lastConsentGroups = (0, oneTrustCookieHelper_1.getConsentGroupsFromCookie)() || [];
function preInit(options = {}) {
    if (window.analytics) {
        (0, debugHelper_1.debugLog)(options, 'Segment analytics-next queue already exists, skipping second pre-init');
        return;
    }
    (0, debugHelper_1.debugLog)(options, 'Pre-init of segment analytics-next queue');
    const analytics = new analytics_next_1.AnalyticsBrowser();
    window.analytics = analytics;
}
function init(key_1) {
    return __awaiter(this, arguments, void 0, function* (key, options = {}) {
        const isNoKeySupplied = typeof key === 'undefined';
        if (isNoKeySupplied) {
            throw new Error('[ONE SEGMENT] Segment Write Key is required');
        }
        prepareClientAndQueue(options);
        yield loadClientWithOptions(key, options);
        window.OptanonWrapper = () => {
            (0, debugHelper_1.debugLog)(options, 'Reinitializing segment analytics-next after consent change');
            (0, windowEventHelper_1.emitWindowEventOnConsentChanged)();
            init(key, options);
        };
        (0, debugHelper_1.debugLog)(options, 'Done initializing segment analytics-next');
    });
}
function prepareClientAndQueue(option) {
    if (!window.analytics) {
        preInit(option);
    }
}
function loadClientWithOptions(key, options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { segmentHost, initialPageTrack } = options;
        exports.segmentWriteKeyForTracking = key;
        if (!(0, oneTrustCookieHelper_1.isOneTrustConsentActive)()) {
            (0, debugHelper_1.debugLog)(options, 'No OneTrust Cookies yet, bailing out');
            return;
        }
        const integrations = yield (0, segmentIntegrations_1.loadIntegrations)({
            writeKey: key,
            host: segmentHost,
        });
        (0, debugHelper_1.debugLog)(options, 'Integrations loaded:', integrations);
        const consentGroups = (0, oneTrustCookieHelper_1.getConsentGroupsFromCookie)();
        (0, debugHelper_1.debugLog)(options, 'ConsentGroups loaded:', consentGroups);
        const hasConsentChanged = JSON.stringify(lastConsentGroups) !== JSON.stringify(consentGroups);
        if (hasConsentChanged) {
            (0, debugHelper_1.debugLog)(options, 'ConsentGroups have changed, sending events');
            (0, trackingHelper_1.trackConsentLevelSet)(key);
            (0, windowEventHelper_1.emitWindowEventOnConsentChanged)();
            lastConsentGroups = consentGroups;
        }
        const debug = (0, debugHelper_1.isDebug)(options);
        const enabledIntegrations = (0, segmentIntegrations_1.determineEnabledIntegrations)(consentGroups, integrations);
        (0, windowEventHelper_1.emitWindowEventOnConsentEvaluated)();
        (0, debugHelper_1.debugLog)(options, 'Enabled Integrations determined:', enabledIntegrations);
        const plugins = (0, plugins_1.getPlugins)(options);
        if ((0, oneTrustCookieHelper_1.isOneTrustConsentActive)()) {
            const fcId = (0, cookies_1.getSessionId)();
            (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.identify({
                fcId,
                acceptedIntegrations: enabledIntegrations,
            });
        }
        (0, debugHelper_1.debugLog)(options, 'Loading segment analytics-next with options', options);
        yield window.analytics.load({ writeKey: key, cdnURL: `https://${segmentHost}`, plugins }, Object.assign(Object.assign({}, options), { integrations: enabledIntegrations, initialPageview: initialPageTrack }));
    });
}
//# sourceMappingURL=init.js.map